import React from "react";
import { MainHeader } from "./MainHeader";
import { MainFooter } from "./MainFooter";

interface MainLayoutProps {
  children: React.ReactNode;
}

const BackgroundPattern = () => (
  <div className="fixed inset-0 -z-10 h-full w-full bg-white dark:bg-gray-950">
    <div className="absolute h-full w-full bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
  </div>
);

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-dvh flex flex-col">
      <BackgroundPattern />
      <MainHeader />
      <main className="flex-1 container mx-auto px-4 flex items-start">
        {children}
      </main>
      <MainFooter />
    </div>
  );
};
